export const fixJson = jsonContent => {
    const dJSON = require('dirty-json');
    const r = dJSON.parse(jsonContent)
    return r;
    
}